import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export interface PerformanceDataPoint {
  date: string;
  value: number;
  benchmark?: number;
}

interface PerformanceChartProps {
  data: PerformanceDataPoint[];
  height?: number;
  valueLabel?: string;
  benchmarkLabel?: string;
  showBenchmark?: boolean;
}

const PerformanceChart = ({
  data,
  height = 300,
  valueLabel = 'Portfolio Value',
  benchmarkLabel = 'Benchmark',
  showBenchmark = false,
}: PerformanceChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="performanceGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} />
        <Tooltip
          formatter={(value: number) => [
            `$${value.toLocaleString()}`,
            valueLabel,
          ]}
        />
        <Area
          type="monotone"
          dataKey="value"
          stroke="#3b82f6"
          strokeWidth={2}
          fill="url(#performanceGradient)"
          name={valueLabel}
        />
        {showBenchmark && (
          <Area
            type="monotone"
            dataKey="benchmark"
            stroke="#94a3b8"
            strokeWidth={1.5}
            fill="transparent"
            name={benchmarkLabel}
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default PerformanceChart;
